import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '热门漫画', href: '/hot-comics' },
  { label: '漫画分类', href: '/categories' },
  { label: '新番预告', href: '/schedule' },
  { label: '帮助中心', href: '/help' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';
  const isTransparent = isHome && !scrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 border-b ${
        isTransparent
          ? 'bg-transparent border-transparent'
          : 'bg-white/95 backdrop-blur-md border-gray-100 shadow-sm'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-16 xl:px-24">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-xl overflow-hidden bg-pink-500 flex items-center justify-center">
              <img
                src="/images/logo/logo.webp"
                alt="天天漫画"
                className="w-full h-full object-cover"
              />
            </div>
            <span
              className={`text-lg md:text-xl font-bold transition-all duration-500 font-serif ${
                isTransparent ? 'text-white opacity-0 -translate-x-2' : 'text-gray-900 opacity-100 translate-x-0'
              }`}
            >
              天天漫画
            </span>
          </Link>

          {/* Desktop Nav — 滚动后显示 */}
          <div className={`hidden md:flex items-center gap-6 lg:gap-8 transition-all duration-500 ${
            isTransparent ? 'opacity-0 translate-y-1 pointer-events-none' : 'opacity-100 translate-y-0'
          }`}>
            {navLinks.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap relative py-1 ${
                    isActive
                      ? 'text-pink-600 font-semibold'
                      : 'text-gray-600 hover:text-pink-500'
                  }`}
                >
                  {item.label}
                  {isActive && (
                    <span className="absolute -bottom-0.5 left-0 right-0 h-0.5 rounded-full bg-pink-500" />
                  )}
                </Link>
              );
            })}
          </div>

          {/* Download CTA — 滚动后显示 */}
          <Link
            to="/download"
            className={`hidden md:inline-flex items-center gap-1.5 text-sm font-medium px-5 py-2 rounded-full transition-all duration-500 whitespace-nowrap ${
              isTransparent
                ? 'opacity-0 scale-95 pointer-events-none'
                : 'opacity-100 scale-100 bg-pink-500 text-white hover:bg-pink-600'
            }`}
          >
            立即下载
          </Link>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors ${
              isTransparent ? 'text-white' : 'text-gray-700'
            }`}
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                    isActive
                      ? 'text-pink-600 font-semibold bg-pink-50'
                      : 'text-gray-700 hover:bg-gray-50 hover:text-pink-500'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
            <Link
              to="/download"
              className="block mt-3 text-center text-sm font-medium px-4 py-3 rounded-full bg-pink-500 text-white"
            >
              立即下载
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}